exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content_line_8[data-v-208142bc]{font-size:15px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:8}.content_all[data-v-208142bc]{font-size:15px}[data-v-208142bc] .van-grid-item .van-grid-item__content{background-color:rgba(255,255,0,0);padding:5px}", ""]);

// exports
